import { Brand } from "../../../models/brand.model.ts";
import { BrandSerializer } from "../../../models/serializers/brandSerializer.ts";
import { httpRequest } from "../../http";
import { BrandAssetFields, brandAssetsUrl } from "./cmdCreateBrandAsset";

/** Changes an asset's details; its file is replaced through CommandReplaceBrandAsset. */
export class CommandUpdateBrandAsset {
    async run(organizationId: string, brandId: string, assetId: number, fields: BrandAssetFields): Promise<Brand> {
        const url = `${brandAssetsUrl(organizationId, brandId)}${assetId}`;
        const response = await httpRequest<any>(url, { method: "PATCH", body: fields });
        return new BrandSerializer().deserialize(response);
    }
}
